import { render, staticRenderFns } from "./QuestionFormActionButton.vue?vue&type=template&id=0618c392"
import script from "./QuestionFormActionButton.vue?vue&type=script&lang=js"
export * from "./QuestionFormActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0618c392')) {
      api.createRecord('0618c392', component.options)
    } else {
      api.reload('0618c392', component.options)
    }
    module.hot.accept("./QuestionFormActionButton.vue?vue&type=template&id=0618c392", function () {
      api.rerender('0618c392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionFormActionButton.vue"
export default component.exports